import { render, staticRenderFns } from "./SharingEntrySimple.vue?vue&type=template&id=13d4a0bb&scoped=true"
import script from "./SharingEntrySimple.vue?vue&type=script&lang=js"
export * from "./SharingEntrySimple.vue?vue&type=script&lang=js"
import style0 from "./SharingEntrySimple.vue?vue&type=style&index=0&id=13d4a0bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4a0bb",
  null
  
)

export default component.exports